module.exports = __webpack_public_path__ + "static/media/def_avatar.88256fca.svg";